import React, { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getImportToken, deleteStudentRegisterImport } from 'store/institutions';

import { Import } from './Import';

export const ImportContainer: FC = () => {
  const dispatch: (...params: any) => Promise<any> = useDispatch();
  const importToken = useSelector(getImportToken);
  const { id } = useParams<{ id: string }>();

  const deleteStudentRegisterImportCallback = useCallback(() => {
    return dispatch(deleteStudentRegisterImport(importToken, id));
  }, [dispatch, importToken, id]);

  return <Import onClose={deleteStudentRegisterImportCallback} token={importToken} />;
};
